
import React from "react";
import { Link } from "react-router-dom";
import { getProfessionData } from "@/data/professionSolutions";
import { Card, CardContent } from "@/components/ui/card";

interface RelatedProfessionsProps {
  relatedProfessions: string[];
}

const RelatedProfessions: React.FC<RelatedProfessionsProps> = ({ relatedProfessions }) => {
  // Filtre uniquement les professions valides qui existent dans les données
  const validProfessions = relatedProfessions.filter(slug => getProfessionData(slug));
  
  if (validProfessions.length === 0) return null;
  
  return (
    <Card className="mt-8">
      <CardContent className="p-6">
        <h3 className="text-xl font-heading font-bold mb-4 text-fabre-gray">
          Solutions pour métiers similaires
        </h3>
        
        <div className="flex flex-wrap gap-2">
          {validProfessions.map((slug) => {
            const profession = getProfessionData(slug);
            if (!profession) return null;
            
            return (
              <Link 
                key={slug}
                to={`/metiers/${slug}`}
                className="px-3 py-1.5 bg-gray-100 hover:bg-fabre-lightgreen hover:text-fabre-green transition-colors rounded-full text-sm"
              >
                {profession.title.replace("Solutions de recyclage pour ", "")}
              </Link>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default RelatedProfessions;
